import React from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import CloseIcon from "assets/images/svg/cancel.svg";

interface MediaDropperComponentProps {
  file?: File;
  onChange?: (file: File | null) => void;
  label? :string;
}

const MediaDropperComponent = ({file = undefined, onChange = (file: File | null) => {},label='Drop a screenshot here' }:MediaDropperComponentProps) => {
  const { t } = useTranslation();

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: { image: ["*"] },
    multiple: false,
    noClick: true,
    onDrop(files) {
      const file = files[0];
      if (file) onChange(file);
    }
  });

  if (file)
    return (
      <div className="media-drop uploadImg">
        {/image/.test(file.type) && <img width={35} src={URL.createObjectURL(file)} alt="preview-attachment" />}
        <p>{file?.name} </p>
        <button className="btn-icon" onClick={() => onChange(null)}>
          <img width="8" height="8" src={CloseIcon} alt="remove-attachment-icon" />
        </button>
      </div>
    );

  return (
    <div className="media-drop">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <p>{label}</p>
        <button className="browse" type="button" onClick={open}>
          {t("admin:addons.slider.browse") as string}
        </button>
      </div>
    </div>
  );
};

export default MediaDropperComponent;
